import PropTypes from 'prop-types'
import { isNil } from 'ramda'

class TicketFollowUpData {
  constructor(init) {
    // console.log('> TicketFollowUpData constructor -', init)
    if (isNil(init)) return undefined
    this._notes = init.notes
    this._scheduled_at = init.scheduled_at
    this._subject = init.subject
    this._ticket_id = init.ticket_id
  }

  static shape = {
    notes: PropTypes.string,
    scheduled_at: PropTypes.string,
    subject: PropTypes.string,
    ticket_id: PropTypes.number
  }

  get notes() {
    return this._notes
  }

  get scheduled_at() {
    return this._scheduled_at
  }

  get subject() {
    return this._subject
  }

  get ticket_id() {
    return this._ticket_id
  }
}

export default TicketFollowUpData
